import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import DeliveryNoteForm from '../../components/pageModule/Deliverynotes/DeliveryNoteForm';
import { updateDeliveryNote, fetchDeliveryNote, setSelected, clearCurrentDeliveryNote } from '../../store/modules/deliverynote/deliverynoteActions';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const DeliverynotesEdit = () => {
    const deliverynoteState = useSelector(state => state.deliverynote);
    const dispatch = useDispatch();
    const { id } = useParams();
    const isInitialized = useRef(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleUpdate = async (formData) => {
        try {
            const response = await dispatch(updateDeliveryNote(id, formData));
            toast.success('Delivery note updated successfully', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            return response;
        } catch (error) {
            toast.error(error.message || 'Error updating delivery note', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const actions = {
        fetchSingle: (id) => dispatch(fetchDeliveryNote(id)),
        update: handleUpdate,
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
        clearCurrent: () => dispatch(clearCurrentDeliveryNote())
    };

    // Fetch function with proper dependencies using actions
    const fetchData = useCallback(async (id) => {
        try {
            setIsLoading(true);
            const data = await actions.fetchSingle(id);
            if(data) {
                const selectedIds = data.items.map(item => item?.item?.id);
                await actions.setItemsSelected({
                    key: 'itemIds',
                    data: selectedIds
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    }, [actions]);

    // Initial data fetch
    useEffect(() => {
        if (!isInitialized.current) {
            isInitialized.current = true;
            fetchData(id);
        }
    }, [fetchData, id]);

    // Cleanup when component unmounts
    useEffect(() => {
        return () => {
            actions.clearCurrent();
        };
    }, [actions]);

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <DeliveryNoteForm 
                                    initialData={deliverynoteState.current}
                                    onSave={async (data) => {
                                        try {
                                            const response = await actions.update(data);
                                            return response;
                                        } catch (error) {
                                            console.error('Error creating item:', error);
                                            throw error;
                                        }
                                    }}
                                    onClose={() => {
                                        console.log('cancel btn clicked')
                                    }}
                                    customActionsDispatch={actions}
                                    isLoading={isLoading}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default DeliverynotesEdit; 